const ORG = 'org_3la_labs';

function nfseBase(overrides) {
  return {
    organizationId: ORG,
    type: 'nfse',
    model: 'NFS-e',
    series: '',
    accessKey: '',
    natureOfOperation: 'Prestação de serviços',
    operationType: 'saida',
    destination: '1',
    purpose: '1',
    consumerFinal: true,
    presence: '1',
    emitter: null,
    recipient: null,
    items: [],
    totals: null,
    transport: null,
    paymentMethod: '',
    duplicates: [],
    xmlFileName: '',
    importedAt: '',
    invoiceId: null,
    supplierId: null,
    supplierName: '',
    iss: 0,
    withholdings: 0,
    netAmount: 0,
    ...overrides,
  };
}

export const invoices = [
  nfseBase({
    id: 'nf_245',
    number: '000245',
    clientId: 'cli_xpto',
    clientName: 'Empresa XPTO Tecnologia',
    service: 'Implantação módulo financeiro',
    description: 'Desenvolvimento e implantação do módulo financeiro',
    date: '01/09/2026',
    issueDate: '01/09/2026',
    amount: 2500,
    iss: 125,
    withholdings: 0,
    netAmount: 2375,
    status: 'Autorizada',
  }),
  nfseBase({
    id: 'nf_244',
    number: '000244',
    clientId: 'cli_emsoft',
    clientName: 'Emsoft Solutions',
    service: 'Suporte mensal',
    description: 'Suporte técnico mensal — agosto/2026',
    date: '28/08/2026',
    issueDate: '28/08/2026',
    amount: 1500,
    iss: 75,
    withholdings: 0,
    netAmount: 1425,
    status: 'Autorizada',
  }),
  nfseBase({
    id: 'nf_243',
    number: '000243',
    clientId: 'cli_horizonte',
    clientName: 'Agência Horizonte',
    service: 'Consultoria de processos',
    description: 'Diagnóstico e mapeamento de processos',
    date: '25/08/2026',
    issueDate: '25/08/2026',
    amount: 5420,
    iss: 271,
    withholdings: 0,
    netAmount: 5149,
    status: 'Processando',
  }),
  nfseBase({
    id: 'nf_242',
    number: '000242',
    clientId: 'cli_alpha',
    clientName: 'Studio Alpha Design',
    service: 'Licenças 3LA Manager',
    description: 'Licenciamento anual — 4 usuários',
    date: '20/08/2026',
    issueDate: '20/08/2026',
    amount: 1200,
    iss: 60,
    withholdings: 0,
    netAmount: 1140,
    status: 'Erro',
  }),
  nfseBase({
    id: 'nf_241',
    number: '000241',
    clientId: 'cli_norte',
    clientName: 'Norte Digital ME',
    service: 'Treinamento operacional',
    description: 'Treinamento cancelado pelo cliente',
    date: '10/08/2026',
    issueDate: '10/08/2026',
    amount: 2500,
    iss: 125,
    withholdings: 0,
    netAmount: 2375,
    status: 'Cancelada',
  }),
  nfseBase({
    id: 'nf_240',
    number: '000240',
    clientId: 'cli_xpto',
    clientName: 'Empresa XPTO Tecnologia',
    service: 'Suporte mensal',
    description: 'Suporte técnico mensal — julho/2026',
    date: '01/08/2026',
    issueDate: '01/08/2026',
    amount: 1500,
    iss: 75,
    withholdings: 0,
    netAmount: 1425,
    status: 'Autorizada',
  }),
  {
    id: 'nfe_3123',
    organizationId: ORG,
    type: 'nfe',
    model: '55',
    series: '1',
    number: '003123',
    accessKey: '35260912345678000190550010000031231000031231',
    natureOfOperation: 'Venda de mercadoria',
    issueDate: '01/09/2026',
    exitDate: '01/09/2026',
    date: '01/09/2026',
    operationType: 'saida',
    destination: '1',
    purpose: '1',
    consumerFinal: true,
    presence: '1',
    clientId: 'cli_xpto',
    clientName: 'Empresa XPTO Tecnologia',
    supplierId: null,
    supplierName: '',
    service: '',
    description: 'Venda de mercadoria — licenças e hardware',
    amount: 5000,
    iss: 0,
    withholdings: 0,
    netAmount: 5000,
    status: 'Autorizada',
    paymentMethod: '15',
    xmlFileName: '',
    importedAt: '',
    emitter: {
      document: '11222333000181',
      stateRegistration: '172.16.0.1',
      name: '3LA Labs Tecnologia LTDA',
      fantasyName: '3LA Labs',
      email: 'fiscal@3lalabs.com',
      address: {
        street: 'Av. Paulista',
        number: '1000',
        complement: 'Sala 101',
        district: 'Bela Vista',
        cityCode: '3550308',
        city: 'São Paulo',
        state: 'SP',
        zipCode: '01310000',
        countryCode: '1058',
        country: 'Brasil',
        phone: '1133334444',
      },
    },
    recipient: {
      document: '12345678000190',
      stateRegistration: '123456789',
      name: 'Empresa XPTO Tecnologia',
      fantasyName: 'XPTO',
      email: 'financeiro@xpto.com.br',
      address: {
        street: 'Rua Augusta',
        number: '500',
        complement: '',
        district: 'Consolação',
        cityCode: '3550308',
        city: 'São Paulo',
        state: 'SP',
        zipCode: '01305000',
        countryCode: '1058',
        country: 'Brasil',
        phone: '11999998888',
      },
    },
    items: [
      {
        itemNumber: 1,
        code: 'LIC-ANUAL',
        ean: 'SEM GTIN',
        description: 'Licença 3LA Manager — anual',
        ncm: '85234990',
        cfop: '5102',
        unit: 'UN',
        qty: 2,
        unitPrice: 1500,
        total: 3000,
        taxes: { icms: 540, ipi: 0, pis: 19.5, cofins: 90 },
      },
      {
        itemNumber: 2,
        code: 'HW-001',
        ean: '7891234567890',
        description: 'Leitor biométrico USB',
        ncm: '84719012',
        cfop: '5102',
        unit: 'UN',
        qty: 4,
        unitPrice: 500,
        total: 2000,
        taxes: { icms: 360, ipi: 0, pis: 13, cofins: 60 },
      },
    ],
    totals: {
      products: 5000,
      freight: 0,
      insurance: 0,
      discount: 0,
      icms: 900,
      ipi: 0,
      pis: 32.5,
      cofins: 150,
      invoice: 5000,
    },
    transport: { modality: '9' },
    duplicates: [
      { number: '001', dueDate: '15/09/2026', amount: 2500 },
      { number: '002', dueDate: '15/10/2026', amount: 2500 },
    ],
  },
  {
    id: 'nfe_imp_088',
    organizationId: ORG,
    type: 'nfe',
    model: '55',
    series: '2',
    number: '000088',
    accessKey: '35260899887766000155550020000000881000000885',
    natureOfOperation: 'Compra para comercialização',
    issueDate: '28/08/2026',
    exitDate: '28/08/2026',
    date: '28/08/2026',
    operationType: 'entrada',
    destination: '1',
    purpose: '1',
    consumerFinal: false,
    presence: '0',
    clientId: null,
    clientName: '',
    supplierId: 'sup_microsoft',
    supplierName: 'Microsoft 365',
    service: '',
    description: 'Aquisição de licenças Microsoft — importada',
    amount: 3300,
    iss: 0,
    withholdings: 0,
    netAmount: 3300,
    status: 'Importada',
    paymentMethod: '15',
    xmlFileName: 'NFe_000088.xml',
    importedAt: '28/08/2026, 14:22:00',
    emitter: {
      document: '99887766000155',
      stateRegistration: 'ISENTO',
      name: 'Microsoft Brasil Softwares LTDA',
      fantasyName: 'Microsoft',
      email: '',
      address: {
        street: 'Av. Presidente Juscelino Kubitschek',
        number: '1909',
        complement: '',
        district: 'Vila Nova Conceição',
        cityCode: '3550308',
        city: 'São Paulo',
        state: 'SP',
        zipCode: '04543011',
        countryCode: '1058',
        country: 'Brasil',
        phone: '',
      },
    },
    recipient: {
      document: '11222333000181',
      stateRegistration: '172.16.0.1',
      name: '3LA Labs Tecnologia LTDA',
      fantasyName: '3LA Labs',
      email: 'fiscal@3lalabs.com',
      address: {
        street: 'Av. Paulista',
        number: '1000',
        complement: 'Sala 101',
        district: 'Bela Vista',
        cityCode: '3550308',
        city: 'São Paulo',
        state: 'SP',
        zipCode: '01310000',
        countryCode: '1058',
        country: 'Brasil',
        phone: '1133334444',
      },
    },
    items: [
      {
        itemNumber: 1,
        code: 'M365-BUS',
        ean: 'SEM GTIN',
        description: 'Microsoft 365 Business — pacote anual',
        ncm: '85234990',
        cfop: '1102',
        unit: 'UN',
        qty: 10,
        unitPrice: 330,
        total: 3300,
        taxes: { icms: 594, ipi: 0, pis: 21.45, cofins: 99 },
      },
    ],
    totals: {
      products: 3300,
      freight: 0,
      insurance: 0,
      discount: 0,
      icms: 594,
      ipi: 0,
      pis: 21.45,
      cofins: 99,
      invoice: 3300,
    },
    transport: { modality: '9' },
    duplicates: [
      { number: '001', dueDate: '10/09/2026', amount: 1100 },
      { number: '002', dueDate: '10/10/2026', amount: 1100 },
      { number: '003', dueDate: '10/11/2026', amount: 1100 },
    ],
  },
];
